import { signal } from '@preact/signals-react'

export type TSettings = Record<string, any>
export type TSettingsItem = { userId: string, key: string; value: any }

export const settings = signal<Record<string, TSettings>>({})

export function getSettings(userId: string, keyOrSettings: string = '', defaultValue: any = null): any {
    const userSettings = settings.value[userId] || {}
    if (!keyOrSettings) return userSettings
    return userSettings.hasOwnProperty(keyOrSettings) ? userSettings[keyOrSettings] : defaultValue
}

export function setSettings(userId: string, keyOrSettings: string | TSettings | null, value?: any) {
    if (!keyOrSettings) return
    if (typeof keyOrSettings === 'string') {
        settings.value = {
            ...settings.value,
            [userId]: {
                ...(settings.value[userId] || {}),
                [keyOrSettings]: value,
            },
        }
    } else {
        settings.value = {
            ...settings.value,
            [userId]: keyOrSettings
        }
    }
}

/**
 * Drops the settings of one user, or of everyone when called without an id.
 *
 * The no-argument case used to delete the entry stored under the empty string,
 * which is nobody — so a call meant to clear everything cleared nothing.
 */
export function resetSettings(userId: string = '') {
    if (!userId) {
        settings.value = {}
        return
    }

    const updated = { ...settings.value }
    delete updated[userId]
    settings.value = updated
}
